import React from 'react';

interface Props {
  bold?: boolean;
}

const VerParagraph: React.FC<Props> = ({ bold, children }) => (
  <React.Fragment>
    {bold ? (
      <p>
        <strong>{children}</strong>
      </p>
    ) : (
      <p>{children}</p>
    )}
    {/* language=CSS */}
    <style jsx>{`
      p {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
      }

      strong {
        font-weight: 500;
      }
    `}</style>
  </React.Fragment>
);

export default VerParagraph;
